import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { buttonStyles } from '../css/commonStyles';
import {
  alertErrorSx,
  alertSuccessSx,
  fieldBlockStyles,
  fieldLabelStyles,
  formFieldStyles,
  managementBoxSx,
  saveButtonSx,
} from '../css/revenueItems.styles';
import { updateDaoVaultAddress } from 'helpers/paymentRequest.api';

const ManagementTab = ({ currentDao, onSaveSuccess }) => {
  const [vaultAddress, setVaultAddress] = useState(currentDao?.vaultAddress ?? '');
  const [isUpdatingVault, setIsUpdatingVault] = useState(false);
  const [vaultUpdateError, setVaultUpdateError] = useState('');
  const [vaultUpdateSuccess, setVaultUpdateSuccess] = useState('');

  useEffect(() => {
    setVaultAddress(currentDao?.vaultAddress ?? '');
  }, [currentDao?.vaultAddress]);

  const handleSave = async () => {
    if (!vaultAddress.trim()) {
      setVaultUpdateError('Vault address is required.');
      return;
    }
    if (!/^0x[0-9a-fA-F]{40}$/.test(vaultAddress.trim())) {
      setVaultUpdateError('Invalid wallet address. Must be a valid Ethereum address (0x...).');
      return;
    }
    try {
      setIsUpdatingVault(true);
      setVaultUpdateError('');
      setVaultUpdateSuccess('');
      await updateDaoVaultAddress(currentDao?._id, vaultAddress.trim());
      setVaultUpdateSuccess('Vault address updated successfully.');
      if (onSaveSuccess) onSaveSuccess();
    } catch (err) {
      setVaultUpdateError(err?.response?.data?.error?.message || err?.message || 'Failed to update vault address.');
    } finally {
      setIsUpdatingVault(false);
    }
  };

  return (
    <Box sx={managementBoxSx}>
      {vaultUpdateError && (
        <Alert severity="error" sx={alertErrorSx}>
          {vaultUpdateError}
        </Alert>
      )}
      {vaultUpdateSuccess && (
        <Alert severity="success" sx={alertSuccessSx}>
          {vaultUpdateSuccess}
        </Alert>
      )}

      <Box sx={fieldBlockStyles}>
        <Typography sx={fieldLabelStyles}>Vault Address</Typography>
        <TextField
          placeholder="0x..."
          value={vaultAddress}
          onChange={(e) => {
            setVaultAddress(e.target.value);
            setVaultUpdateError('');
            setVaultUpdateSuccess('');
          }}
          fullWidth
          sx={formFieldStyles}
        />
      </Box>

      <Button
        variant="contained"
        onClick={handleSave}
        disabled={isUpdatingVault}
        sx={{ ...buttonStyles, ...saveButtonSx }}
      >
        {isUpdatingVault ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save'}
      </Button>
    </Box>
  );
};

export default ManagementTab;
